export default __webpack_public_path__ + "static/media/footer.65b7dc2b.png";